// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__12roL","list":"PatternAutocomplete_list__D0aIC"};